<template>
  <div class="card card-custom card-transparent">
    <div class="card-body p-0">
      <div style="margin-bottom: 10px">
        <b-button variant="primary" @click="exportExcel('2022')"
          ><i class="fa fa-download" aria-hidden="true" />Export PM PPB KL
          (2022)
        </b-button>
        <b-button variant="primary" @click="exportExcel('2023')" class="ml-1"
          ><i class="fa fa-download" aria-hidden="true" />Export PM PPB KL
          (2023)
        </b-button>
        <b-button variant="primary" @click="exportExcel('2024')" class="ml-1"
          ><i class="fa fa-download" aria-hidden="true" />Export PM PPB KL
          (2024)
        </b-button>
      </div>
      <!--begin: Wizard-->
      <div
        class="wizard wizard-4"
        id="kt_wizard_v4"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav-->
        <div class="wizard-nav">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              data-wizard-type="step"
              data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-number">1</div>
                <div class="wizard-label">
                  <div class="wizard-title">Penerapan Perizinan Berusaha</div>
                  <div class="wizard-desc">Penerapan Perizinan Berusaha</div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">2</div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    Penyederhanaan Perizinan Berusaha Sektor
                  </div>
                  <div class="wizard-desc">
                    Penyederhanaan Perizinan Berusaha Sektor
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">3</div>
                <div class="wizard-label">
                  <div class="wizard-title">Peningkatan Iklim Investasi</div>
                  <div class="wizard-desc">Peningkatan Iklim Investasi</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body-->
        <div class="card card-custom card-shadowless rounded-top-0">
          <div class="card-body p-0">
            <div
              class="row justify-content-center py-12 px-8 py-lg-15 px-lg-10"
            >
              <div class="col-xl-12 col-xxl-10">
                <!--begin: Wizard Form-->
                <form class="form mt-0 mt-lg-10" id="kt_form">
                  <!--begin: Wizard Step 1-->
                  <div
                    class="pb-5"
                    data-wizard-type="step-content"
                    data-wizard-state="current"
                  >
                    <div v-if="pm.catatan_1_surveyor != null">
                      <b-alert show variant="danger"
                        >Terdapat catatan, silahkan lihat catatan
                        dibawah!</b-alert
                      >
                    </div>
                    <div
                      style="background-color: #1bc5bd"
                      class="card card-custom"
                    >
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i
                            class="fa fa-info-circle"
                            style="color: white"
                            aria-hidden="true"
                          ></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Penyederhanaan
                          Penerapan Perizinan Berusaha berdasarkan fakta yang
                          ada dengan memilih data yang sesuai. Dokumen lampiran
                          yang diunggah adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow"
                            >halaman pengesahan</strong
                          >
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Unggah</th>
                            <th style="display: none">Hapus</th>
                            <th style="display: none">Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b
                                >Penyusunan NSPK terkait penerapan perizinan
                                berusaha</b
                              >
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan NSPK dengan
                              Kementerian Terkait lainnya?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Untuk Kementerian Negara/ Lembaga (K/L) yang telah
                              memiliki NSPK, yang dimaksud dalam tolok ukur di
                              sini adalah konsultasi dalam rangka evaluasi atas
                              NSPK yang sudah ada. Termasuk jika ada KBLI yang
                              belum diatur/diampu di dalam PP No. 5 Tahun 2021.
                              Penilaian konsultasi pengusulan NSPK dengan
                              Kementerian terkait lainnya dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a1_file1"
                                v-b-tooltip.hover
                                title="Undangan rapat konsultasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a1_file1)"
                                v-if="pm.p1a1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a1_file2"
                                v-b-tooltip.hover
                                title="Undangan rapat konsultasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a1_file2)"
                                v-if="pm.p1a1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a1_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a1_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a1_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a1_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a1_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a1_file3)"
                                v-if="pm.p1a1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a1_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a1_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a1_file4"
                                v-b-tooltip.hover
                                title="Notula Rapat"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a1_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a1_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a1_file4)"
                                v-if="pm.p1a1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a1_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a1_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a1_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto rapat konsultasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a1_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a1_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a1_file5)"
                                v-if="pm.p1a1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada harmonisasi pengusulan NSPK dengan
                              Kementerian Terkait lainnya?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Pilihan pada indikator dan tolok ukur ini
                              menyesuaikan dengan Pilihan pada indikator
                              Penyusunan NSPK terkait penerapan perizinan
                              berusaha. Penilaian harmonisasi pengusulan NSPK
                              dengan Kementerian terkait lainnya
                              (sekurang-kurangnya melibatkan Kementerian
                              Koordinator Bidang Perekonomian, Sekretariat
                              Kabinet, atau Kementerian Investasi/BKPM)
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a2_file1"
                                v-b-tooltip.hover
                                title="Undangan rapat harmonisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a2_file1)"
                                v-if="pm.p1a2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a2_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a2_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a2_file2"
                                v-b-tooltip.hover
                                title="Undangan rapat harmonisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a2_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a2_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a2_file2)"
                                v-if="pm.p1a2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a2_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a2_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a2_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a2_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a2_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a2_file3)"
                                v-if="pm.p1a2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a2_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a2_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a2_file4"
                                v-b-tooltip.hover
                                title="Notula Rapat"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a2_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a2_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a2_file4)"
                                v-if="pm.p1a2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a2_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a2_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a2_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto rapat "
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a2_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a2_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a2_file5)"
                                v-if="pm.p1a2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="3">3</td>
                            <td rowspan="3">
                              Apakah ada dokumen NSPK terkait penerapan
                              Perizinan Berusaha?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  @change="onFileChangedp1a3_file1_radio"
                                  v-model="pm.p1a3_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p1a3_nilai"
                                  value="25"
                                  >Ada, sudah disahkan</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp1a3_file1_radio"
                                  v-model="pm.p1a3_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p1a3_nilai"
                                  value="10"
                                  >Ada, belum disahkan</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp1a3_file1_radio"
                                  v-model="pm.p1a3_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p1a3_nilai"
                                  value="0"
                                  >Belum ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a3_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a3_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a3_file1"
                                v-b-tooltip.hover
                                title="Peraturan Menteri/ Peraturan Kepala Badan tentang NSPK terkait perizinan berusaha berbasis risiko (jika sudah disahkan)"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a3_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a3_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a3_file1)"
                                v-if="pm.p1a3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr colspan="4">
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a3_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a3_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a3_file2"
                                v-b-tooltip.hover
                                title="Draf Permen/ Peraturan Kepala Badan tentang NSPK terkait perizinan berusaha berbasis risiko (jika belum disahkan) "
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a3_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a3_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a3_file2)"
                                v-if="pm.p1a3_file2 != null"
                                v-b-tooltip.hover
                                title="Unduh"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div
                                  class="card-body text-green"
                                  style="color: white; text-align: justify"
                                >
                                  <p>Informasi</p>
                                  <p>
                                    Penilaian ada tidaknya dokumen NSPK terkait
                                    penerapan Perizinan berusaha dilakukan
                                    dengan ketentuan tersedia dokumen NSPK
                                    terkait penerapan Perizinan berusaha dalam
                                    lembaran negara. Untuk penetapan bobot
                                    penilaian:
                                  </p>

                                  <ol style="margin-left: 11px">
                                    <li>
                                      Nilai &ldquo;Ada, sudah disahkan&rdquo;
                                      apabila ketentuan di atas terpenuhi.
                                    </li>
                                    <li>
                                      Nilai &ldquo;Ada, belum disahkan&rdquo;
                                      apabila ketentuan di atas tidak terpenuhi
                                      namun sudah tersedia dalam bentuk
                                      naskah/dokumen usulan.
                                    </li>
                                    <li>
                                      Nilai &ldquo;Belum ada&rdquo; apabila
                                      ketentuan di atas tidak terpenuhi
                                    </li>
                                  </ol>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada kegiatan Sosialisasi NSPK Penerapan
                              Perizinan Berusaha?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian ada tidaknya Sosialisasi NSPK Penerapan
                              Perizinan Berusaha dilakukan dengan ketentuan:
                              sosialisasi dilakukan sekurang-kurangnya 1 kali
                              dalam 3 bulan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Sosialisasi dilakukan secara Nasional
                                  sekurang-kurangnya dilakukan di tingkat
                                  Provinsi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a4_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a4_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a4_file1"
                                v-b-tooltip.hover
                                title="Undangan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a4_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a4_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a4_file1)"
                                v-if="pm.p1a4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a4_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a4_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a4_file2"
                                v-b-tooltip.hover
                                title="Undangan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a4_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a4_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a4_file2)"
                                v-if="pm.p1a4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a4_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a4_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a4_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir peserta"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a4_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a4_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a4_file3)"
                                v-if="pm.p1a4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a4_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a4_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a4_file4"
                                v-b-tooltip.hover
                                title="Notula Sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a4_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a4_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a4_file4)"
                                v-if="pm.p1a4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1a4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1a4_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1a4_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1a4_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto rapat"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1a4_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1a4_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1a4_file5)"
                                v-if="pm.p1a4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b
                                >Integrasi sistem Kementrian Negara/Lembaga
                                dengan sistem OSS</b
                              >
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">
                              Apakah memiliki sistem di K/L yang terintegrasi
                              dengan OSS atau menggunakan sistem OSS dengan hak
                              akses?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian integrasi sistem atau penggunaan hak
                              akses OSS oleh kementerian negara/lembaga
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1b1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Semua pemrosesan permohonan perizinan berusaha
                                  sektor berdasarkan lampiran PP No. 5 Tahun
                                  2021 yang menjadi kewenangannya menggunakan
                                  sistem K/L yang terintegrasi dengan OSS
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1b1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1b1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1b1_file1"
                                v-b-tooltip.hover
                                title="Buku panduan sistem sistem KL yang terintegrasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1b1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1b1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1b1_file1)"
                                v-if="pm.p1b1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1b1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Semua pemrosesan permohonan perizinan berusaha
                                  sektor berdasarkan lampiran PP No. 5 Tahun
                                  2021 yang menjadi kewenangannya menggunakan
                                  sistem OSS dengan hak akses
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1b1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1b1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1b1_file2"
                                v-b-tooltip.hover
                                title="Dokumen hak akses"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1b1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1b1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1b1_file2)"
                                v-if="pm.p1b1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Memiliki sistem dan Terintegrasi”
                                    apabila ketentuan nomor 1 terpenuhi.<br />
                                    2. Nilai “Tidak memiliki sistem dan
                                    menggunakan hak akses” apabila ketentuan
                                    nomor 2 terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="3">2</td>
                            <td rowspan="3">
                              Berapa persen tingkat verifikasi teknis dan
                              notifikasi pemenuhan standar dan persyaratan
                              Perizinan Berusaha Berbasis Risiko?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  @change="onFileChangedp1b2_file1_radio"
                                  v-model="pm.p1b2_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p1b2_nilai"
                                  value="25"
                                  >85 – 100%</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp1b2_file1_radio"
                                  v-model="pm.p1b2_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p1b2_nilai"
                                  value="15"
                                  >70 – 84,99%</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp1b2_file1_radio"
                                  v-model="pm.p1b2_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p1b2_nilai"
                                  value="10"
                                  >50 – 69,99%</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp1b2_file1_radio"
                                  v-model="pm.p1b2_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p1b2_nilai"
                                  value="0"
                                  >di bawah 50%</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1b2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1b2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1b2_file1"
                                v-b-tooltip.hover
                                title=" Dokumen bukti permohonan risiko MT yang masuk dan verifikasinya di sistem OSS"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1b2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1b2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1b2_file1)"
                                v-if="pm.p1b2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1b2_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1b2_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1b2_file2"
                                v-b-tooltip.hover
                                title=" Dokumen bukti permohonan risiko T yang masuk dan verifikasinya di sistem OSS"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1b2_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1b2_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1b2_file2)"
                                v-if="pm.p1b2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div
                                  class="card-body text-green"
                                  style="color: white; text-align: justify"
                                >
                                  <p>Informasi</p>
                                  <p>
                                    Penilaian verifikasi teknis dan notifikasi
                                    pemenuhan standar dan persyaratan Perizinan
                                    Berusaha Berbasis Risiko dilakukan dengan
                                    ketentuan:
                                  </p>

                                  <ol style="margin-left: 11px">
                                    <li>
                                      Verifikasi teknis dan notifikasi pemenuhan
                                      standar oleh K/L terhadap permohonan
                                      perizinan berusaha dengan tingkat risiko
                                      Menengah Tinggi (MT) yang menjadi
                                      kewenangannya.
                                    </li>
                                    <li>
                                      Verifikasi teknis dan notifikasi pemenuhan
                                      persyaratan oleh K/L terhadap permohonan
                                      perizinan berusaha dengan tingkat risiko
                                      Tinggi (T) yang menjadi kewenangannya.
                                    </li>
                                    <li>
                                      Penilaian verifikasi teknis dan notifikasi
                                      pemenuhan standar dan persyaratan
                                      Perizinan Berusaha Berbasis Risiko
                                      dilakukan dengan menghitung perbandingan
                                      jumlah permohonan perizinan berusaha
                                      dengan tingkat risiko MT dan T yang telah
                                      diverifikasi dengan total permohonan
                                      perizinan berusaha yang masuk ke dalam
                                      dashboard OSS K/L.
                                    </li>
                                  </ol>
                                </div>
                              </div>
                            </td>
                          </tr>


                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada kegiatan monitoring dan evaluasi
                              implementasi Perizinan Berusaha?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian ada tidaknya kegiatan monitoring dan
                              evaluasi implementasi Perizinan Berusaha dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1c1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Kegiatan monitoring dan evaluasi dilakukan
                                  sekurang-kurangnya 1 kali dalam 1 semester
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1c1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1c1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1c1_file1"
                                v-b-tooltip.hover
                                title=" Undangan kegitan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1c1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1c1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1c1_file1)"
                                v-if="pm.p1c1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1c1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1c1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1c1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1c1_file2"
                                v-b-tooltip.hover
                                title=" Undangan kegitan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1c1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1c1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1c1_file2)"
                                v-if="pm.p1c1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1c1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1c1_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1c1_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1c1_file3"
                                v-b-tooltip.hover
                                title="Daftar Hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1c1_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1c1_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1c1_file3)"
                                v-if="pm.p1c1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1c1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula Monev</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1c1_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1c1_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1c1_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1c1_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1c1_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1c1_file4)"
                                v-if="pm.p1c1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1c1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1c1_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1c1_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1c1_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1c1_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1c1_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1c1_file5)"
                                v-if="pm.p1c1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada laporan kinerja implementasi Perizinan
                              Berusaha?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p1c2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya laporan kinerja
                                  implementasi perizinan berusaha dilakukan
                                  dengan ketentuan apabila laporan kinerja
                                  implementasi Perizinan Berusaha dibuat secara
                                  formal dalam bentuk dokumen laporan lengkap
                                  fisik atau digital, bukan bahan presentasi dan
                                  sejenisnya
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp1c2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p1c2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp1c2_file1"
                                v-b-tooltip.hover
                                title="Laporan (kinerja) Implementasi Perizinan Berusaha "
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p1c2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p1c2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p1c2_file1)"
                                v-if="pm.p1c2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- <div class="row">
                            <div class="col-6">

                            </div>
                            <div class="col-6">
                                <button type="button" @click="getjumlah('1')" style="float: right;" class="btn btn-success font-weight-bolder text-uppercase"><i class="fas fa-save"></i>Simpan Form</button>
                            </div>
                        </div> -->
                      <br />
                      <div v-if="pm.catatan_1_surveyor != null">
                        <div class="card text-white bg-primary mb-3">
                          <!-- <div class="card-header">Header</div> -->
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_1_surveyor"
                            ></div>
                            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end: Wizard Step 1-->

                  <!--begin: Wizard Step 2-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <div v-if="pm.catatan_2_surveyor != null">
                      <b-alert show variant="danger"
                        >Terdapat catatan, silahkan lihat catatan
                        dibawah!</b-alert
                      >
                    </div>
                    <div
                      style="background-color: #1bc5bd"
                      class="card card-custom"
                    >
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i
                            class="fa fa-info-circle"
                            style="color: white"
                            aria-hidden="true"
                          ></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Penyederhanaan
                          Perizinan Berusaha Sektor berdasarkan fakta yang ada
                          dengan memilih data yang sesuai. Dokumen lampiran yang
                          diunggah adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow"
                            >halaman pengesahan</strong
                          >
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Unggah</th>
                            <th style="display: none">Hapus</th>
                            <th style="display: none">Download</th>
                          </tr>
                        </thead>
                        <tbody>

                          <!-- Hide 2026 -->

                          <!-- <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b
                                >Penapisan bidang usaha berdasarkan tingkat
                                risiko</b
                              >
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="3">1</td>
                            <td rowspan="3">
                              Apakah ada kegiatan penapisan bidang usaha
                              berdasarkan risiko?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  @change="onFileChangedp2a1_file1_radio"
                                  v-model="pm.p2a1_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2a1_nilai"
                                  value="25"
                                  >Ada, semua</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp2a1_file1_radio"
                                  v-model="pm.p2a1_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2a1_nilai"
                                  value="10"
                                  >Ada, Sebagian</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp2a1_file1_radio"
                                  v-model="pm.p2a1_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2a1_nilai"
                                  value="0"
                                  >Tidak ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2a1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2a1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2a1_file1"
                                v-b-tooltip.hover
                                title="BA kegiatan penapisan"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2a1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2a1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2a1_file1)"
                                v-if="pm.p2a1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2a1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2a1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2a1_file2"
                                v-b-tooltip.hover
                                title="Surat  Sekretaris Menteri Koordinator Bidang Perekonomian Nomor No. PI.01./433/SES.M.EKON/06/202"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2a1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2a1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2a1_file2)"
                                v-if="pm.p2a1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div
                                  class="card-body text-green"
                                  style="color: white; text-align: justify"
                                >
                                  <p>Informasi</p>
                                  <p>
                                    Penilaian ada tidaknya kegiatan penapisan
                                    bidang usaha berdasarkan risiko dilakukan
                                    dengan ketentuan:
                                  </p>

                                  <ol style="margin-left: 11px">
                                    <li>
                                      K/L melakukan penapisan pada semua KBLI
                                      yang disebutkan dalam PP No. 5 Tahun 2021.
                                    </li>
                                    <li>
                                      K/L melakukan penapisan KBLI sesuai surat
                                      Sekretaris Menteri Koordinator Bidang
                                      Perekonomian Nomor No.
                                      PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                      Juni 2021 perihal KBLI Beririsan dan KBLI
                                      Tanpa K/L Pengampu.
                                    </li>
                                    <li>
                                      K/L yang tidak memiliki kewajiban
                                      melakukan penapisan pada KLBI sesuai surat
                                      Sekretaris Menteri Koordinator Bidang
                                      Perekonomian Nomor No.
                                      PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                      Juni 2021 perihal KBLI Beririsan dan KBLI
                                      Tanpa K/L Pengampu.
                                    </li>
                                  </ol>

                                  <p>Nilai &ldquo;Ada, semua&rdquo; apabila</p>

                                  <ol style="margin-left: 11px">
                                    <li>Ketentuan nomor 1 dan 2 terpenuhi.</li>
                                    <li>Ketentuan nomor 1 dan 3 terpenuhi.</li>
                                  </ol>

                                  <p>
                                    Nilai &ldquo;Ada, sebagian&rdquo; apabila
                                  </p>

                                  <ol style="margin-left: 11px">
                                    <li>
                                      K/L melakukan penapisan pada semua KBLI
                                      yang disebutkan dalam PP No. 5 Tahun 2021.
                                      Namun, tidak melakukan penapisan terhadap
                                      semua KBLI sesuai surat Sekretaris Menteri
                                      Koordinator Bidang Perekonomian Nomor No.
                                      PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                      Juni 2021 perihal KBLI Beririsan dan KBLI
                                      Tanpa K/L Pengampu, maupun sebaliknya.
                                    </li>
                                    <li>
                                      K/L melakukan penapisan pada sebagian KBLI
                                      yang disebutkan dalam PP No. 5 Tahun 2021.
                                      Namun, telah melakukan penapisan pada
                                      semua KBLI sesuai surat Sekretaris Menteri
                                      Koordinator Bidang Perekonomian Nomor No.
                                      PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                      Juni 2021 perihal KBLI Beririsan dan KBLI
                                      Tanpa K/L, maupun sebaliknya.
                                    </li>
                                    <li>
                                      K/L melakukan penapisan pada sebagian baik
                                      atas KBLI yang disebutkan dalam PP No. 5
                                      Tahun 2021 maupun pada KBLI sesuai surat
                                      Sekretaris Menteri Koordinator Bidang
                                      Perekonomian Nomor No.
                                      PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                      Juni 2021 perihal KBLI Beririsan dan KBLI
                                      Tanpa K/L.
                                    </li>
                                  </ol>

                                  <p>
                                    Nilai &ldquo;Tidak ada&rdquo; apabila
                                    seluruh ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="4">2</td>
                            <td rowspan="4">
                              Apakah ada hasil penapisan bidang usaha
                              berdasarkan risiko?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian ada tidaknya hasil penapisan bidang
                              usaha berdasarkan risiko dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2a2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  tolok ukur ini sesuai dengan penilaian pada
                                  tolok ukur menilai ada tidaknya kegiatan
                                  penapisan bidang usaha berdasarkan risiko dan
                                  wajib menunjukkan dokumen hasil penapisan pada
                                  seluruh KBLI yang menjadi kewenangannya
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2a2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2a2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2a2_file1"
                                v-b-tooltip.hover
                                title="Dokumen hasil penapisan bidang usaha berdasarkan risiko"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2a2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2a2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2a2_file1)"
                                v-if="pm.p2a2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2a2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  K/L yang tidak memiliki kewajiban melakukan
                                  penapisan pada KBLI sesuai surat Sekretaris
                                  Menteri Koordinator Bidang Perekonomian Nomor
                                  No. PI.01./433/SES.M.EKON/06/2021 tanggal 16
                                  Juni 2021 perihal KBLI Beririsan dan KBLI
                                  Tanpa K/L Pengampu
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2a2_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2a2_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2a2_file2"
                                v-b-tooltip.hover
                                title="Surat Menteri Kordinator Bidang Perekonomian"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2a2_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2a2_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2a2_file2)"
                                v-if="pm.p2a2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, semua” apabila ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Ada, sebagian” apabila salah satu
                                    ketentuan di atas tidak terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b
                                >Penyusunan NSPK berdasarkan penapisan bidang
                                usaha</b
                              >
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada konsultasi pengusulan NSPK dengan
                              Kementerian Terkait lainnya?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Untuk K/L yang telah memiliki NSPK, yang dimaksud
                              dalam tolok ukur di sini adalah konsultasi dalam
                              rangka evaluasi atas NSPK yang sudah ada. Termasuk
                              penapisan pada KBLI sesuai surat Sekretaris
                              Menteri Koordinator Bidang Perekonomian Nomor No.
                              PI.01./433/SES.M.EKON/06/2021 tanggal 16 Juni 2021
                              perihal KBLI Beririsan dan KBLI Tanpa K/L
                              Pengampu. Penilaian konsultasi pengusulan NSPK
                              dengan Kementerian terkait lainnya
                              (sekurang-kurangnya melibatkan Kementerian
                              Koordinator Bidang Perekonomian, Sekretariat
                              Kabinet, atau Kementerian Investasi/BKPM)
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 6 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b1_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan konsultasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b1_file1)"
                                v-if="pm.p2b1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b1_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan konsultasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b1_file2)"
                                v-if="pm.p2b1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b1_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b1_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b1_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b1_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b1_file3)"
                                v-if="pm.p2b1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b1_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b1_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b1_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b1_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b1_file4)"
                                v-if="pm.p2b1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b1_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b1_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b1_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan konsultasi "
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b1_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b1_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b1_file5)"
                                v-if="pm.p2b1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada harmonisasi pengusulan NSPK dengan
                              Kementerian Terkait lainnya?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Untuk K/L yang telah memiliki NSPK, yang dimaksud
                              dalam tolok ukur di sini adalah harmonisasi dalam
                              rangka Evaluasi atas NSPK yang sudah ada. Termasuk
                              penapisan pada KBLI sesuai surat Sekretaris
                              Menteri Koordinator Bidang Perekonomian Nomor No.
                              PI.01./433/SES.M.EKON/06/2021 tanggal 16 Juni 2021
                              perihal KBLI Beririsan dan KBLI Tanpa K/L
                              Pengampu. Penilaian harmonisasi pengusulan NSPK
                              dengan Kementerian terkait lainnya
                              (sekurang-kurangnya melibatkan Kementerian
                              Koordinator Bidang Perekonomian, Sekretariat
                              Kabinet, atau Kementerian Investasi/BKPM)
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b2_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan harmonisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b2_file1)"
                                v-if="pm.p2b2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b2_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b2_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan harmonisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b2_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b2_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b2_file2)"
                                v-if="pm.p2b2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b2_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b2_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b2_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b2_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b2_file3)"
                                v-if="pm.p2b2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b2_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b2_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b2_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b2_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b2_file4)"
                                v-if="pm.p2b2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b2_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b2_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b2_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan harmonisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b2_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b2_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b2_file5)"
                                v-if="pm.p2b2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="3">3</td>
                            <td rowspan="3">
                              Apakah ada NSPK berdasarkan penapisan bidang
                              usaha?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  @change="onFileChangedp2b3_file1_radio"
                                  v-model="pm.p2b3_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b3_nilai"
                                  value="25"
                                  >Ada, sudah disahkan</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp2b3_file1_radio"
                                  v-model="pm.p2b3_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b3_nilai"
                                  value="10"
                                  >Ada, belum disahkan</b-form-radio
                                >
                                <b-form-radio
                                  @change="onFileChangedp2b3_file1_radio"
                                  v-model="pm.p2b3_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b3_nilai"
                                  value="0"
                                  >Belum ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b3_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b3_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b3_file1"
                                v-b-tooltip.hover
                                title="Peraturan Menteri/ Peraturan Kepala Badan tentang NSPK bidang usaha"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b3_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b3_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b3_file1)"
                                v-if="pm.p2b3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr colspan="4">
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b3_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b3_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b3_file2"
                                v-b-tooltip.hover
                                title="Rancangan Peraturan Menteri/ Peraturan Kepala Badan tentang NSPK bidang usaha"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b3_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b3_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b3_file2)"
                                v-if="pm.p2b3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Penilaian ada tidaknya dokumen NSPK
                                    berdasarkan penapisan bidang usaha dilakukan
                                    dengan ketentuan tersedia dokumen NSPK
                                    berdasarkan penapisan bidang usaha dalam
                                    lembaran negara
                                  </p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, sudah disahkan” apabila salah
                                    satu ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, belum disahkan” apabila
                                    seluruh ketentuan di atas tidak terpenuhi
                                    namun sudah tersedia dalam bentuk
                                    naskah/dokumen usulan. <br />
                                    3. Nilai “Belum ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="8">4</td>
                            <td rowspan="8">
                              Apakah ada kegiatan sosialisasi NSPK penapisan
                              bidang usaha berdasarkan tingkat risiko?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian ada tidaknya kegiatan sosialisasi NSPK
                              penapisan bidang usaha berdasarkan tingkat risiko
                              dilakukan dengan ketentuan
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Sosialisasi dilakukan sekurang-kurangnya 1
                                  kali dalam 1 semester
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b4_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b4_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b4_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b4_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b4_file1)"
                                v-if="pm.p2b4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Sosialisasi dilakukan secara Nasional
                                  sekurang-kurangnya dilakukan di tingkat
                                  Provinsi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b4_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b4_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b4_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b4_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b4_file2)"
                                v-if="pm.p2b4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b4_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b4_file3"
                                v-b-tooltip.hover
                                title="Undangan kegitan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b4_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b4_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b4_file3)"
                                v-if="pm.p2b4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b4_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b4_file4"
                                v-b-tooltip.hover
                                title="Daftar Hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b4_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b4_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b4_file4)"
                                v-if="pm.p2b4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b4_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b4_file5"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b4_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b4_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b4_file5)"
                                v-if="pm.p2b4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2b4_file6 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2b4_file6"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2b4_file6"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2b4_file6"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan sosialisasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2b4_file6 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2b4_file6')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2b4_file6)"
                                v-if="pm.p2b4_file6 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, hanya 1 kali” apabila salah
                                    satu dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr> -->
                          
                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada monitoring dan evaluasi implementasi
                              penapisan bidang usaha berdasarkan tingkat risiko?
                            </td>
                            <td colspan="4" style="text-align: justify">
                              Penilaian ada tidaknya monitoring dan evaluasi
                              implementasi penapisan bidang usaha berdasarkan
                              tingkat risiko dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2c1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Kegiatan monitoring dan evaluasi dilakukan
                                  sekurang-kurangnya 1 kali dalam 1 semester
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2c1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2c1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2c1_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2c1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2c1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2c1_file1)"
                                v-if="pm.p2c1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2c1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2c1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2c1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2c1_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2c1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2c1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2c1_file2)"
                                v-if="pm.p2c1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2c1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2c1_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2c1_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2c1_file3"
                                v-b-tooltip.hover
                                title="Daftar Hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2c1_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2c1_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2c1_file3)"
                                v-if="pm.p2c1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2c1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2c1_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2c1_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2c1_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2c1_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2c1_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2c1_file4)"
                                v-if="pm.p2c1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p2c1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp2c1_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p2c1_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp2c1_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p2c1_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p2c1_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p2c1_file5)"
                                v-if="pm.p2c1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>

                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <br />
                      <div v-if="pm.catatan_2_surveyor != null">
                        <div class="card text-white bg-primary mb-3">
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_2_surveyor"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end: Wizard Step 2-->

                  <!--begin: Wizard Step 3-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <div v-if="pm.catatan_3_surveyor != null">
                      <b-alert show variant="danger"
                        >Terdapat catatan, silahkan lihat catatan
                        dibawah!</b-alert
                      >
                    </div>

                    <div
                      style="background-color: #1bc5bd"
                      class="card card-custom"
                    >
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i
                            class="fa fa-info-circle"
                            style="color: white"
                            aria-hidden="true"
                          ></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Peningkatan Iklim
                          Investasi berdasarkan fakta yang ada dengan memilih
                          data yang sesuai. Dokumen lampiran yang diunggah
                          adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow"
                            >halaman pengesahan</strong
                          >
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Unggah</th>
                            <th style="display: none">Hapus</th>
                            <th style="display: none">Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b>Unit Pelaksana PPB</b>
                            </td>
                          </tr>
                          <!-- Hide 2026 -->
                          <!-- <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">
                              Apakah ada Organisasi Pelaksana PPB?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya Organisasi Pelaksana PPB
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  K/L memiliki dan dapat menunjukkan penetapan/
                                  keputusan dari Menteri/Kepala Lembaga
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a1_file1"
                                v-b-tooltip.hover
                                title="Surat Keputusan Menteri/ Kepala Badan tentang Pembentukan dan/atau Susunan Organisasi Pelaksana PBB"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a1_file1)"
                                v-if="pm.p3a1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  K/L memiliki ruang sekretariat organisasi tim
                                  internal K/L yang melaksanakan tugas dan
                                  fungsi PPB
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a1_file2"
                                v-b-tooltip.hover
                                title="Ruang Sekretariat Organisasi Pelaksana PBB"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a1_file2)"
                                v-if="pm.p3a1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila kedua ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila salah satu
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr> -->
                          <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">Apakah ada program kerja PPB?</td>
                            <td colspan="4">
                              Penilaian ada tidaknya program kerja PPB dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  K/L memiliki dan dapat menunjukkan bukti
                                  program kerja
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a2_file1"
                                v-b-tooltip.hover
                                title="Program Kerja Organisasi Pelaksana PBB"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a2_file1)"
                                v-if="pm.p3a2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  K/L memiliki dan dapat menunjukkan bukti
                                  realisasi program kerja (sekurang-kurangnya
                                  50% dari program kerja yang direncanakan)
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a2_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a2_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a2_file2"
                                v-b-tooltip.hover
                                title="Laporan realisasi program kerja organisasi Pelaksana PPB"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a2_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a2_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a2_file2)"
                                v-if="pm.p3a2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila kedua ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila salah satu
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada rapat koordinasi unit pelaksana PPB?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya rapat koordinasi teragenda
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 1 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a3_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a3_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a3_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan rapat koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a3_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a3_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a3_file1)"
                                v-if="pm.p3a3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a3_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a3_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a3_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan rapat koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a3_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a3_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a3_file2)"
                                v-if="pm.p3a3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a3_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a3_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a3_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a3_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a3_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a3_file3)"
                                v-if="pm.p3a3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a3_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a3_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a3_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a3_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a3_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a3_file4)"
                                v-if="pm.p3a3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3a3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3a3_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3a3_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3a3_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan rapat koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3a3_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3a3_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3a3_file5)"
                                v-if="pm.p3a3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b
                                >Koordinasi Formal Lintas Pemangku
                                kepentingan</b
                              >
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan sesama
                              instansi Pusat?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya koordinasi formal dengan
                              sesama instansi Pusat dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 6 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b1_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b1_file1)"
                                v-if="pm.p3b1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b1_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b1_file2)"
                                v-if="pm.p3b1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b1_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b1_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b1_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b1_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b1_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b1_file3)"
                                v-if="pm.p3b1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b1_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b1_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b1_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b1_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b1_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b1_file4)"
                                v-if="pm.p3b1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b1_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b1_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b1_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b1_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b1_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b1_file5)"
                                v-if="pm.p3b1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan Pemerintah
                              Provinsi?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya koordinasi formal dengan
                              Provinsi dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b2_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b2_file1)"
                                v-if="pm.p3b2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b2_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b2_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b2_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b2_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b2_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b2_file2)"
                                v-if="pm.p3b2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b2_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b2_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b2_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b2_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b2_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b2_file3)"
                                v-if="pm.p3b2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b2_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b2_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b2_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b2_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b2_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b2_file4)"
                                v-if="pm.p3b2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b2_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b2_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b2_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b2_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b2_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b2_file5)"
                                v-if="pm.p3b2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan Pemerintah
                              Kab/Kota?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya koordinasi formal dengan
                              Pemda Kabupaten/Kota dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b3_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b3_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b3_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b3_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b3_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b3_file1)"
                                v-if="pm.p3b3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b3_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b3_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b3_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b3_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b3_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b3_file2)"
                                v-if="pm.p3b3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b3_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b3_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b3_file3"
                                v-b-tooltip.hover
                                title="Daftar hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b3_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b3_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b3_file3)"
                                v-if="pm.p3b3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b3_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b3_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b3_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b3_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b3_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b3_file4)"
                                v-if="pm.p3b3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b3_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b3_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b3_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b3_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b3_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b3_file5)"
                                v-if="pm.p3b3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada koordinasi pemangku kepentingan lainnya
                              (Perbankan dan APH)?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya koordinasi pemangku
                              kepentingan lainnya (Perbankan dan APH) dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b4_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b4_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b4_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b4_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b4_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b4_file1)"
                                v-if="pm.p3b4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b4_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b4_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b4_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b4_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b4_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b4_file2)"
                                v-if="pm.p3b4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b4_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b4_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b4_file3"
                                v-b-tooltip.hover
                                title="Daftar Hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b4_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b4_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b4_file3)"
                                v-if="pm.p3b4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b4_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b4_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b4_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b4_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b4_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b4_file4)"
                                v-if="pm.p3b4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3b4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3b4_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3b4_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3b4_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan koordinasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3b4_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3b4_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3b4_file5)"
                                v-if="pm.p3b4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada kegiatan monitoring dan evaluasi hasil
                              peningkatan iklim investasi?
                            </td>
                            <td colspan="4">
                              Penilaian ada tidaknya kegiatan monitoring dan
                              evaluasi hasil peningkatan iklim investasi
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3c1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3c1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3c1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3c1_file1"
                                v-b-tooltip.hover
                                title="Undangan kegitan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3c1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3c1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3c1_file1)"
                                v-if="pm.p3c1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3c1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3c1_file2"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3c1_file2"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3c1_file2"
                                v-b-tooltip.hover
                                title="Undangan kegitan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3c1_file2 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3c1_file2')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3c1_file2)"
                                v-if="pm.p3c1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3c1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3c1_file3"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3c1_file3"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3c1_file3"
                                v-b-tooltip.hover
                                title="Daftar Hadir"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3c1_file3 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3c1_file3')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3c1_file3)"
                                v-if="pm.p3c1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3c1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3c1_file4"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3c1_file4"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3c1_file4"
                                v-b-tooltip.hover
                                title="Notula"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3c1_file4 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3c1_file4')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3c1_file4)"
                                v-if="pm.p3c1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="pm.p3c1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3c1_file5"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3c1_file5"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3c1_file5"
                                v-b-tooltip.hover
                                title="Dokumentasi foto kegiatan Monev"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3c1_file5 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3c1_file5')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3c1_file5)"
                                v-if="pm.p3c1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada laporan hasil monitoring peningkatan
                              iklim investasi?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3c2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya laporan hasil
                                  monitoring peningkatan iklim investasi
                                  dilakukan dengan ketentuan apabila laporan
                                  hasil monitoring peningkatan iklim investasi
                                  dibuat secara formal dalam bentuk dokumen
                                  laporan lengkap fisik atau digital, bukan
                                  bahan presentasi dan sejenisnya
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3c2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3c2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3c2_file1"
                                v-b-tooltip.hover
                                title="Dokumen Laporan Hasil Monev peningkatan iklim investasi"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3c2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3c2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3c2_file1)"
                                v-if="pm.p3c2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="6" style="background-color: #ebedf3">
                              <b>Tindak lanjut atas hasil Evaluasi</b>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">1</td>
                            <td rowspan="2">
                              Apakah ada evaluasi hasil kinerja PPB tahun
                              sebelumnya?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3d1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  <p>
                                    Penilaian ada tidaknya evaluasi hasil
                                    kinerja PPB tahun sebelumnya dilakukan
                                    dengan ketentuan
                                  </p>

                                  <ol style="margin-left: 15px">
                                    <li>
                                      Terdapat surat undangan resmi (melibatkan
                                      pihak eksternal) dalam bentuk fisik atau
                                      digital
                                    </li>
                                    <li>
                                      Terdapat daftar hadir peserta rapat dalam
                                      bentuk fisik atau digital
                                    </li>
                                    <li>Terdapat notula rapat</li>
                                    <li>
                                      Terdapat dokumentasi rapat dalam bentuk
                                      foto
                                    </li>
                                  </ol>
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3d1_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3d1_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3d1_file1"
                                v-b-tooltip.hover
                                title="Dokumen Rencana Tindak Lanjut hasil evaluasi kinerja PPB tahun sebelumnya"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3d1_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3d1_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3d1_file1)"
                                v-if="pm.p3d1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada penambahan alokasi anggaran (rutin)
                              pelayanan perizinan berusaha?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="pm.p3d2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya penambahan alokasi
                                  anggaran (rutin) pelayanan perizinan berusaha
                                  dilakukan dengan ketentuan apabila ada
                                  penambahan alokasi anggaran (rutin) pelayanan
                                  perizinan berusaha.
                                </div>
                              </div>
                            </td>
                            <td>
                              <input
                                :key="fileInputKey"
                                @change="onFileChangedp3d2_file1"
                                accept=".pdf"
                                type="file"
                                id="file"
                                ref="p3d2_file1"
                                class="custom-file-input"
                                hidden
                              />
                              <button
                                @click="previewFilesp3d2_file1"
                                v-b-tooltip.hover
                                title="Dokumen Alokasi Anggaran Rutin Pelayanan Perizinan Tahun 2022 dan Tahun 2023"
                                type="button"
                                style="
                                  background-color: #030a8c;
                                  border-color: #030a8c;
                                "
                                size="sm"
                                class="btn btn-primary text-uppercase btn-sm"
                              >
                                <i class="flaticon-upload"></i> Unggah File
                              </button>
                            </td>
                            <td>
                              <a
                                v-if="pm.p3d2_file1 != null"
                                type="button"
                                data-toggle="Hapus"
                                data-placement="top"
                                title="Hapus"
                                @click="deleteFile('p3d2_file1')"
                              >
                                <i
                                  style="color: red"
                                  class="flaticon2-trash"
                                ></i>
                              </a>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(pm.p3d2_file1)"
                                v-if="pm.p3d2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian:
                                    <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- <div class="row">
                            <div class="col-6">

                            </div>
                            <div class="col-6">
                                <button type="button" @click="getjumlah('3')" style="float: right;" class="btn btn-success font-weight-bolder text-uppercase"><i class="fas fa-save"></i>Simpan Form</button>
                            </div>
                        </div> -->
                      <br />
                      <div v-if="pm.catatan_3_surveyor != null">
                        <div class="card text-white bg-primary mb-3">
                          <!-- <div class="card-header">Header</div> -->
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_3_surveyor"
                            ></div>
                            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end: Wizard Step 3-->

                  <!--begin: Wizard Actions -->
                  <div class="d-flex justify-content-between border-top pt-10">
                    <div class="mr-2">
                      <button
                        class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-prev"
                      >
                        Sebelumnya
                      </button>
                    </div>
                    <div>
                      <button
                        v-on:click="submit"
                        class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-submit"
                      >
                        Selesai
                      </button>
                      <button
                        class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-next"
                      >
                        Simpan
                      </button>
                    </div>
                  </div>
                  <!--end: Wizard Actions -->
                </form>
                <!--end: Wizard Form-->
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Bpdy-->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</template>
  
<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-7.scss";
</style>
  
  
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import axios from "axios";
import VueLoading from "vuejs-loading-plugin";
import Vue from "vue";

Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});

export default {
  name: "Wizard-4",
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "PM PPB KL" }]);

    // Initialize form wizard
    const wizard = new KTWizard("kt_wizard_v4", {
      startStep: 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    // Validation before going to next page
    wizard.on("beforeNext", function (/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    wizard.on("change", (e) => {
      this.getjumlah(e.currentStep);
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });

    this.loadData();
  },
  data() {
    return {
      bagian: [
        { value: "kadis", text: "Kepala Dinas" },
        { value: "kabidpb", text: "Kepala Bidang Perizinan Berusaha" },
        { value: "kasiepb", text: "Kepala Seksi Bidang Perizinan Berusaha" },
        {
          value: "foffpb",
          text: "Staf Front-office Bidang Perizinan Berusaha",
        },
        { value: "boffpb", text: "Staf Back-office Bidang Perizinan Berusaha" },
        { value: "hdeskpb", text: "Staf Help Desk Bidang Perizinan Berusaha" },
        { value: "kabiddal", text: "Kepala Bidang Dalaks" },
        { value: "kasiedal", text: "Kepala Seksi Bidang Dalaks" },
        { value: "foffdal", text: "Staf Front-office Bidang Dalaks" },
        { value: "boffdal", text: "Staf Back-office Bidang Dalaks" },
        { value: "hdeskdal", text: "Staf Help Desk Bidang Dalaks" },
      ],
      vf: [],
      pm: [],
      id_verifikasi: null,
      profil: [],
      fileInputKey: 0,
    };
  },
  props: {
    user: {
      type: Array,
      default: () => {
        return [];
      },
    },
    url: String,
    token: String,
    idpm: String,
    idptsp: String,
    idppb: String,
    idprofil: String,
    tahun: String,
  },
  methods: {
    submit: function (e) {
      e.preventDefault();
      this.getjumlah(3);
      Swal.fire({
        title: "",
        text: "Pengisian telah selesai",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
      });
      this.$router.push({ name: "dashboard" });
    },

    exportExcel(data) {
      window.open(
        this.url + `/export/ppb_kl/` + this.user.id_ptsp + `/` + data,
        "_blank"
      );
      // Swal.fire({
      //     title: 'Export PM PTSP Pemda',
      //     showDenyButton: true,
      //     showCancelButton: false,
      //     confirmButtonText: '2022',
      //     denyButtonText: '2023',
      //     }).then((result) => {
      //     /* Read more about isConfirmed, isDenied below */
      //     if (result.isConfirmed) {
      //         window.open(this.url+`/export/pm_pemda/`+this.user.id_ptsp+`/2022`, '_blank')
      //     } else if (result.isDenied) {
      //         window.open(this.url+`/export/pm_pemda/`+this.user.id_ptsp+`/2023`, '_blank')
      //     }
      //     })
    },

    unduhFile(data) {
      window.open(data, "_blank");
    },
    loadData() {
      axios
        .get(this.url + `/pm_ppb_kl_2026s?filter=id,=,` + this.idppb, {
          headers: {
            xth: this.token,
          },
        })
        .then((response) => {
          this.pm = response.data.data;
        })
        .catch((error) => {
          return error;
        });

      axios
        .get(this.url + `/profil_ppb_kls?filter=idkl,=,` + this.user.id_ptsp, {
          headers: {
            xth: this.token,
          },
        })
        .then((response) => {
          this.profil = response.data.data;
        });
    },
    deleteFile(data) {
      Swal.fire({
        title: "Apakah Anda yakin?",
        text: "Anda tidak bisa mengembalikan file ini",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya, Hapus File",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .put(
              this.url + "/pm_ppb_kl_2026_delete_lampiran",
              {
                idkl: this.user.id_ptsp,
                tahun: this.tahun,
                field: data,
              },
              {
                headers: {
                  xth: this.token,
                },
              }
            )
            .then((res) => {
              this.$bvToast.toast("Berhasil Dihapus", {
                title: `Success `,
                variant: `success`,
                solid: true,
              });
              this.loadData();
              this.fileInputKey++;
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$bvToast.toast("Gagal Dihapus", {
                title: `Failed `,
                variant: `danger`,
                solid: true,
              });
              return err;
            });
        }
      });
    },
    getjumlah(data) {
      axios
        .put(
          this.url + "/pm_ppb_kl_2026_final",
          {
            idkl: this.user.id_ptsp,
            tahun: this.tahun,
            form: data,
          },
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((res) => {
          this.$bvToast.toast("Berhasil Disimpan", {
            title: `Success `,
            variant: `success`,
            solid: true,
          });
          this.loadData();
          return res;
        })
        .catch((err) => {
          return err;
        });
    },
    previewFilesp1a1_file1() {
      this.$refs.p1a1_file1.click();
    },
    onFileChangedp1a1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a1_file1", this.pm.p1a1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a1_file2() {
      this.$refs.p1a1_file2.click();
    },
    onFileChangedp1a1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a1_file2", this.pm.p1a1_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a1_file3() {
      this.$refs.p1a1_file3.click();
    },
    onFileChangedp1a1_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a1_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a1_file3", this.pm.p1a1_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            console.log(response.data);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a1_file4() {
      this.$refs.p1a1_file4.click();
    },
    onFileChangedp1a1_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a1_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a1_file4", this.pm.p1a1_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        this.loadData();
      }
    },

    previewFilesp1a1_file5() {
      this.$refs.p1a1_file5.click();
    },
    onFileChangedp1a1_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a1_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a1_file5", this.pm.p1a1_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a2_file1() {
      this.$refs.p1a2_file1.click();
    },
    onFileChangedp1a2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a2_file1", this.pm.p1a2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a2_file2() {
      this.$refs.p1a2_file2.click();
    },
    onFileChangedp1a2_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a2_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a2_file2", this.pm.p1a2_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a2_file3() {
      this.$refs.p1a2_file3.click();
    },
    onFileChangedp1a2_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a2_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a2_file3", this.pm.p1a2_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a2_file4() {
      this.$refs.p1a2_file4.click();
    },
    onFileChangedp1a2_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a2_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a2_file4", this.pm.p1a2_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a2_file5() {
      this.$refs.p1a2_file5.click();
    },
    onFileChangedp1a2_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a2_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a2_file5", this.pm.p1a2_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a3_file1() {
      this.$refs.p1a3_file1.click();
    },
    onFileChangedp1a3_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a3_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a3_file1", this.pm.p1a3_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },
    onFileChangedp1a3_file1_radio() {
      this.$loading(true);
      let formData = new FormData();
      formData.append("p1a3_nilai", this.pm.p1a3_nilai);
      axios
        .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
          // _method: 'patch',
          headers: {
            xth: this.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$loading(false);
          this.$bvToast.toast("Berhasil Disimpan", {
            title: `Success `,
            variant: `success`,
            solid: true,
          });
          // console.log(response);

          this.loadData();

          return response;
        })
        .catch((error) => {
          console.log(error);
          this.$loading(false);
          this.loadData();
          this.$bvToast.toast(error.response.data.message, {
            title: `Failed `,
            variant: `danger`,
            solid: true,
          });
          return error;
        });
      console.log(this.selectedFile);
    },

    previewFilesp1a3_file2() {
      this.$refs.p1a3_file2.click();
    },
    onFileChangedp1a3_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a3_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a3_file2", this.pm.p1a3_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a4_file1() {
      this.$refs.p1a4_file1.click();
    },
    onFileChangedp1a4_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a4_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a4_file1", this.pm.p1a4_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a4_file2() {
      this.$refs.p1a4_file2.click();
    },
    onFileChangedp1a4_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a4_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a4_file2", this.pm.p1a4_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a4_file3() {
      this.$refs.p1a4_file3.click();
    },
    onFileChangedp1a4_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a4_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a4_file3", this.pm.p1a4_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a4_file4() {
      this.$refs.p1a4_file4.click();
    },
    onFileChangedp1a4_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a4_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a4_file4", this.pm.p1a4_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1a4_file5() {
      this.$refs.p1a4_file5.click();
    },
    onFileChangedp1a4_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1a4_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1a4_file5", this.pm.p1a4_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1b1_file1() {
      this.$refs.p1b1_file1.click();
    },
    onFileChangedp1b1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1b1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1b1_file1", this.pm.p1b1_file1);

        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1b1_file2() {
      this.$refs.p1b1_file2.click();
    },
    onFileChangedp1b1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1b1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1b1_file2", this.pm.p1b1_file2);

        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1b2_file1() {
      this.$refs.p1b2_file1.click();
    },
    onFileChangedp1b2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1b2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1b2_file1", this.pm.p1b2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    onFileChangedp1b2_file1_radio() {
      this.$loading(true);
      let formData = new FormData();
      formData.append("p1b2_nilai", this.pm.p1b2_nilai);
      axios
        .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
          // _method: 'patch',
          headers: {
            xth: this.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$loading(false);
          this.$bvToast.toast("Berhasil Disimpan", {
            title: `Success `,
            variant: `success`,
            solid: true,
          });
          // console.log(response);

          this.loadData();

          return response;
        })
        .catch((error) => {
          console.log(error);
          this.$loading(false);
          this.loadData();
          this.$bvToast.toast(error.response.data.message, {
            title: `Failed `,
            variant: `danger`,
            solid: true,
          });
          return error;
        });
      console.log(this.selectedFile);
    },

    previewFilesp1b2_file2() {
      this.$refs.p1b2_file2.click();
    },
    onFileChangedp1b2_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1b2_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1b2_file2", this.pm.p1b2_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1c1_file1() {
      this.$refs.p1c1_file1.click();
    },
    onFileChangedp1c1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1c1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1c1_file1", this.pm.p1c1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1c1_file2() {
      this.$refs.p1c1_file2.click();
    },
    onFileChangedp1c1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1c1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1c1_file2", this.pm.p1c1_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1c1_file3() {
      this.$refs.p1c1_file3.click();
    },
    onFileChangedp1c1_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1c1_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1c1_file3", this.pm.p1c1_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1c1_file4() {
      this.$refs.p1c1_file4.click();
    },
    onFileChangedp1c1_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1c1_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1c1_file4", this.pm.p1c1_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1c1_file5() {
      this.$refs.p1c1_file5.click();
    },
    onFileChangedp1c1_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1c1_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1c1_file5", this.pm.p1c1_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp1c2_file1() {
      this.$refs.p1c2_file1.click();
    },
    onFileChangedp1c2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p1c2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p1c2_file1", this.pm.p1c2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    //   form2
    previewFilesp2a1_file1() {
      this.$refs.p2a1_file1.click();
    },
    onFileChangedp2a1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2a1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2a1_file1", this.pm.p2a1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },
    onFileChangedp2a1_file1_radio() {
      this.$loading(true);
      let formData = new FormData();
      formData.append("p2a1_nilai", this.pm.p2a1_nilai);
      axios
        .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
          // _method: 'patch',
          headers: {
            xth: this.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$loading(false);
          this.$bvToast.toast(response.data.message, {
            title: `Success `,
            variant: `success`,
            solid: true,
          });
          // console.log(response);

          this.loadData();

          return response;
        })
        .catch((error) => {
          console.log(error);
          this.$loading(false);
          this.loadData();
          this.$bvToast.toast(error.response.data.message, {
            title: `Failed `,
            variant: `danger`,
            solid: true,
          });
          return error;
        });
      console.log(this.selectedFile);
    },

    previewFilesp2a1_file2() {
      this.$refs.p2a1_file2.click();
    },
    onFileChangedp2a1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        this.$loading(true);
        this.pm.p2a1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2a1_file2", this.pm.p2a1_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2a2_file1() {
      this.$refs.p2a2_file1.click();
    },
    onFileChangedp2a2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2a2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2a2_file1", this.pm.p2a2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2a2_file2() {
      this.$refs.p2a2_file2.click();
    },
    onFileChangedp2a2_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2a2_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2a2_file2", this.pm.p2a2_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b1_file1() {
      this.$refs.p2b1_file1.click();
    },
    onFileChangedp2b1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b1_file1", this.pm.p2b1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b1_file2() {
      this.$refs.p2b1_file2.click();
    },
    onFileChangedp2b1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b1_file2", this.pm.p2b1_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b1_file3() {
      this.$refs.p2b1_file3.click();
    },
    onFileChangedp2b1_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b1_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b1_file3", this.pm.p2b1_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b1_file4() {
      this.$refs.p2b1_file4.click();
    },
    onFileChangedp2b1_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b1_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b1_file4", this.pm.p2b1_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b1_file5() {
      this.$refs.p2b1_file5.click();
    },
    onFileChangedp2b1_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b1_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b1_file5", this.pm.p2b1_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b2_file1() {
      this.$refs.p2b2_file1.click();
    },
    onFileChangedp2b2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b2_file1", this.pm.p2b2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b2_file2() {
      this.$refs.p2b2_file2.click();
    },
    onFileChangedp2b2_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b2_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b2_file2", this.pm.p2b2_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b2_file3() {
      this.$refs.p2b2_file3.click();
    },
    onFileChangedp2b2_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b2_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b2_file3", this.pm.p2b2_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b2_file4() {
      this.$refs.p2b2_file4.click();
    },
    onFileChangedp2b2_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b2_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b2_file4", this.pm.p2b2_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b2_file5() {
      this.$refs.p2b2_file5.click();
    },
    onFileChangedp2b2_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b2_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b2_file5", this.pm.p2b2_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b3_file1() {
      this.$refs.p2b3_file1.click();
    },
    onFileChangedp2b3_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b3_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b3_file1", this.pm.p2b3_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },
    onFileChangedp2b3_file1_radio() {
      this.$loading(true);
      let formData = new FormData();
      formData.append("p2b3_nilai", this.pm.p2b3_nilai);
      axios
        .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
          // _method: 'patch',
          headers: {
            xth: this.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$loading(false);
          this.$bvToast.toast("Berhasil Disimpan", {
            title: `Success `,
            variant: `success`,
            solid: true,
          });
          // console.log(response);

          this.loadData();

          return response;
        })
        .catch((error) => {
          console.log(error);
          this.$loading(false);
          this.loadData();
          this.$bvToast.toast(error.response.data.message, {
            title: `Failed `,
            variant: `danger`,
            solid: true,
          });
          return error;
        });
      console.log(this.selectedFile);
    },

    previewFilesp2b3_file2() {
      this.$refs.p2b3_file2.click();
    },
    onFileChangedp2b3_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b3_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b3_file2", this.pm.p2b3_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b4_file1() {
      this.$refs.p2b4_file1.click();
    },
    onFileChangedp2b4_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b4_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b4_file1", this.pm.p2b4_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b4_file2() {
      this.$refs.p2b4_file2.click();
    },
    onFileChangedp2b4_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b4_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b4_file2", this.pm.p2b4_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b4_file3() {
      this.$refs.p2b4_file3.click();
    },
    onFileChangedp2b4_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b4_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b4_file3", this.pm.p2b4_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b4_file4() {
      this.$refs.p2b4_file4.click();
    },
    onFileChangedp2b4_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b4_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b4_file4", this.pm.p2b4_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b4_file5() {
      this.$refs.p2b4_file5.click();
    },
    onFileChangedp2b4_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b4_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b4_file5", this.pm.p2b4_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2b4_file6() {
      this.$refs.p2b4_file6.click();
    },
    onFileChangedp2b4_file6(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2b4_file6 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2b4_file6", this.pm.p2b4_file6);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2c1_file1() {
      this.$refs.p2c1_file1.click();
    },
    onFileChangedp2c1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2c1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2c1_file1", this.pm.p2c1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2c1_file2() {
      this.$refs.p2c1_file2.click();
    },
    onFileChangedp2c1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2c1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2c1_file2", this.pm.p2c1_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2c1_file3() {
      this.$refs.p2c1_file3.click();
    },
    onFileChangedp2c1_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2c1_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2c1_file3", this.pm.p2c1_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2c1_file4() {
      this.$refs.p2c1_file4.click();
    },
    onFileChangedp2c1_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2c1_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2c1_file4", this.pm.p2c1_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp2c1_file5() {
      this.$refs.p2c1_file5.click();
    },
    onFileChangedp2c1_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p2c1_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p2c1_file5", this.pm.p2c1_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    //   form3

    previewFilesp3a1_file1() {
      this.$refs.p3a1_file1.click();
    },
    onFileChangedp3a1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a1_file1", this.pm.p3a1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3a1_file2() {
      this.$refs.p3a1_file2.click();
    },
    onFileChangedp3a1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a1_file2", this.pm.p3a1_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3a2_file1() {
      this.$refs.p3a2_file1.click();
    },
    onFileChangedp3a2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a2_file1", this.pm.p3a2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3a2_file2() {
      this.$refs.p3a2_file2.click();
    },
    onFileChangedp3a2_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a2_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a2_file2", this.pm.p3a2_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3a3_file1() {
      this.$refs.p3a3_file1.click();
    },
    onFileChangedp3a3_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a3_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a3_file1", this.pm.p3a3_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3a3_file2() {
      this.$refs.p3a3_file2.click();
    },
    onFileChangedp3a3_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a3_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a3_file2", this.pm.p3a3_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3a3_file3() {
      this.$refs.p3a3_file3.click();
    },
    onFileChangedp3a3_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a3_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a3_file3", this.pm.p3a3_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3a3_file4() {
      this.$refs.p3a3_file4.click();
    },
    onFileChangedp3a3_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a3_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a3_file4", this.pm.p3a3_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3a3_file5() {
      this.$refs.p3a3_file5.click();
    },
    onFileChangedp3a3_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3a3_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3a3_file5", this.pm.p3a3_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b1_file1() {
      this.$refs.p3b1_file1.click();
    },
    onFileChangedp3b1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b1_file1", this.pm.p3b1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b1_file2() {
      this.$refs.p3b1_file2.click();
    },
    onFileChangedp3b1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b1_file2", this.pm.p3b1_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b1_file3() {
      this.$refs.p3b1_file3.click();
    },
    onFileChangedp3b1_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b1_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b1_file3", this.pm.p3b1_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b1_file4() {
      this.$refs.p3b1_file4.click();
    },
    onFileChangedp3b1_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b1_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b1_file4", this.pm.p3b1_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b1_file5() {
      this.$refs.p3b1_file5.click();
    },
    onFileChangedp3b1_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b1_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b1_file5", this.pm.p3b1_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b2_file1() {
      this.$refs.p3b2_file1.click();
    },
    onFileChangedp3b2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b2_file1", this.pm.p3b2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b2_file2() {
      this.$refs.p3b2_file2.click();
    },
    onFileChangedp3b2_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b2_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b2_file2", this.pm.p3b2_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b2_file3() {
      this.$refs.p3b2_file3.click();
    },
    onFileChangedp3b2_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b2_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b2_file3", this.pm.p3b2_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b2_file4() {
      this.$refs.p3b2_file4.click();
    },
    onFileChangedp3b2_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b2_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b2_file4", this.pm.p3b2_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b2_file5() {
      this.$refs.p3b2_file5.click();
    },
    onFileChangedp3b2_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b2_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b2_file5", this.pm.p3b2_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b3_file1() {
      this.$refs.p3b3_file1.click();
    },
    onFileChangedp3b3_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b3_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b3_file1", this.pm.p3b3_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b3_file2() {
      this.$refs.p3b3_file2.click();
    },
    onFileChangedp3b3_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b3_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b3_file2", this.pm.p3b3_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b3_file3() {
      this.$refs.p3b3_file3.click();
    },
    onFileChangedp3b3_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b3_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b3_file3", this.pm.p3b3_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b3_file4() {
      this.$refs.p3b3_file4.click();
    },
    onFileChangedp3b3_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b3_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b3_file4", this.pm.p3b3_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b3_file5() {
      this.$refs.p3b3_file5.click();
    },
    onFileChangedp3b3_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b3_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b3_file5", this.pm.p3b3_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b4_file1() {
      this.$refs.p3b4_file1.click();
    },
    onFileChangedp3b4_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b4_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b4_file1", this.pm.p3b4_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b4_file2() {
      this.$refs.p3b4_file2.click();
    },
    onFileChangedp3b4_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b4_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b4_file2", this.pm.p3b4_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b4_file3() {
      this.$refs.p3b4_file3.click();
    },
    onFileChangedp3b4_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b4_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b4_file3", this.pm.p3b4_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b4_file4() {
      this.$refs.p3b4_file4.click();
    },
    onFileChangedp3b4_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b4_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b4_file4", this.pm.p3b4_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3b4_file5() {
      this.$refs.p3b4_file5.click();
    },
    onFileChangedp3b4_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3b4_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3b4_file5", this.pm.p3b4_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3c1_file1() {
      this.$refs.p3c1_file1.click();
    },
    onFileChangedp3c1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3c1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3c1_file1", this.pm.p3c1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3c1_file2() {
      this.$refs.p3c1_file2.click();
    },
    onFileChangedp3c1_file2(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3c1_file2 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3c1_file2", this.pm.p3c1_file2);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3c1_file3() {
      this.$refs.p3c1_file3.click();
    },
    onFileChangedp3c1_file3(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3c1_file3 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3c1_file3", this.pm.p3c1_file3);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3c1_file4() {
      this.$refs.p3c1_file4.click();
    },
    onFileChangedp3c1_file4(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3c1_file4 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3c1_file4", this.pm.p3c1_file4);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3c1_file5() {
      this.$refs.p3c1_file5.click();
    },
    onFileChangedp3c1_file5(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3c1_file5 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3c1_file5", this.pm.p3c1_file5);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3c2_file1() {
      this.$refs.p3c2_file1.click();
    },
    onFileChangedp3c2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3c2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3c2_file1", this.pm.p3c2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3d1_file1() {
      this.$refs.p3d1_file1.click();
    },
    onFileChangedp3d1_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3d1_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3d1_file1", this.pm.p3d1_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },

    previewFilesp3d2_file1() {
      this.$refs.p3d2_file1.click();
    },
    onFileChangedp3d2_file1(e) {
      this.selectedFile = e.target.files[0];
      var fsize = this.selectedFile.size;
      var file = Math.round(fsize / 1024);
      // The size of the file.
      console.log(file);
      if (file >= 500) {
        console.log(file);
        Swal.fire({
          title: "",
          text: "File terlalu besar, pilih file maksimal 500 kb",
          icon: "danger",
          confirmButtonClass: "btn btn-danger",
        });
        this.selectedFile = null;
      } else {
        console.log(this.selectedFile);
        this.$loading(true);
        this.pm.p3d2_file1 = this.selectedFile;
        let formData = new FormData();
        formData.append("p3d2_file1", this.pm.p3d2_file1);
        axios
          .post(this.url + "/pm_ppb_kl_2026/" + this.idppb, formData, {
            // _method: 'patch',
            headers: {
              xth: this.token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$loading(false);
            this.$bvToast.toast(response.data.message, {
              title: `Success `,
              variant: `success`,
              solid: true,
            });
            // console.log(response);

            this.loadData();

            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$loading(false);
            this.loadData();
            this.$bvToast.toast(error.response.data.message, {
              title: `Failed `,
              variant: `danger`,
              solid: true,
            });
            return error;
          });
        console.log(this.selectedFile);
      }
    },
    downloadItem(url) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
  },
};
</script>
  
<style scoped>
@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 768px) {
  /* Force table to not be like tables anymore */
  table,
  thead,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 10px 1rem 1rem 1rem;
  }

  /* tr:nth-child(odd) {
      background: #E1EDFF;
    } */

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    /* padding-left: 50%; */
  }

  th {
    display: none;
  }

  /* td:before { */
  /* Now like a table header */
  /* position: absolute; */
  /* Top/left values mimic padding */
  /* top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap; */
  /* } */

  /*
		Label the data
    You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
		*/
  /* td:nth-of-type(1):before { content: "No"; }
		td:nth-of-type(2):before { content: "Indikator"; }
		td:nth-of-type(3):before { content: "Status"; }
		td:nth-of-type(4):before { content: "Jawaban"; }
        td:nth-of-type(5):before { content: "Unggah"; } 
        td:nth-of-type(6):before { content: "Download"; }  */
}
</style>